import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from 'react-redux';

function ProductListingAttributes(props) {
  const oldData = (props.listingData && props.listingData.catalogData) || {};
  const newData = (props.listingData && props.listingData.formData) || {};

  const [attributes, setAttributes] = useState(
    props.listingData && props.listingData.formData 
      ? props.listingData.formData 
      : { bullets: [] } 
  );

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (props.listingData && props.listingData.formData) {
      setAttributes(props.listingData.formData);
    }
  }, [props.listingData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAttributes(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBulletChange = (index, value) => {
    const updatedBullets = [...(attributes.bullets || [])];
    updatedBullets[index] = value;
    
    setAttributes(prev => ({
      ...prev,
      bullets: updatedBullets
    }));
  };

  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        ...attributes
      }
    }));

    props.nextStep();
  };

  const oldDesc = oldData.description || "N/A";
  const descLimit = 150;
  const showToggle = oldDesc.length > descLimit;

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 4 : Product Attributes</h4>
        </Col>

        <Col md={12} className="ml-1 mr-4">
          <Card className="p-4">
            
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Item Name : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.productTitle || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="productTitle" 
                  value={attributes.productTitle || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Brand : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.brand || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="brand"
                  value={attributes.brand || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Color : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.color || "N/A"}</p>
              </Col>
              <Col md={6}>
                 <Input
                  type="text"
                  name="color"
                  value={attributes.color || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Size : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.size || "N/A"}</p>
              </Col>
              <Col md={6}>
              <Input 
                type="text" 
                name="size" 
                value={attributes.size || ""}
                onChange={handleChange}
              />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Material : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.material || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="material"
                  value={attributes.material || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {(attributes.bullets || []).map((bullet, index) => {
              const oldBullet = (oldData.bullets && oldData.bullets[index]) ? oldData.bullets[index] : "N/A";
              
              return (
                <Row className="mb-3 align-items-center" key={`bullet-${index}`}>
                  <Col md={2} className="amazon-listing-labels">Bullet Point {index + 1} :</Col>
                  <Col md={4}>
                    <p className="mb-0">{oldBullet}</p>
                  </Col>
                  <Col md={6}>
                    <Input
                      type="text"
                      value={bullet}
                      onChange={(e) => handleBulletChange(index, e.target.value)}
                    />
                  </Col>
                </Row>
              );
            })}

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Description : </Col>
              <Col md={4}>
                <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                  {showToggle && !isExpanded 
                    ? `${oldDesc.substring(0, descLimit)}...` 
                    : oldDesc}
                  {showToggle && (
                    <span 
                      style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px', fontWeight: 'bold' }} 
                      onClick={() => setIsExpanded(!isExpanded)}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </span>
                  )}
                </p>
              </Col>
              <Col md={6}>
                <Input
                  type="textarea"
                  rows="4"
                  name="description"
                  value={attributes.description || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>
          <button
            className="btn btn-primary"
            onClick={handleNext} 
          >
            Next →
          </button>
        </Col>

      </Row>
    </Container>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
  }
}

export default connect(mapStateToProps)(ProductListingAttributes);